<div class="like-container">
	<span>{{likes}}</span>
	<img src="/assets/images/forum/thumbs-up.svg" [alt]="likes + 'People liked'" height="15" width="15"
		*ngIf="!isLiked">
	<img src="/assets/images/forum/thumbs-up-filled.svg" [alt]="likes + 'People liked'" height="15" width="15"
		*ngIf="isLiked">
</div>